<v-layout>
  <v-navigation-drawer v-model="model" class="pa-2" :width="500" location="right" permanent>
    <v-card variant="text" title="Log Entries" subtitle="Most current on top"></v-card>
    <v-card variant="outlined" v-for="item in itemsToDisplay" :border="item.border" class="mb-2">
      <v-chip label size="x-small" prepend-icon="mdi-clock-outline" class="float-right ma-1">
        {{ formatDate(item.timestamp) }}
      </v-chip>
      <v-chip v-if="!item.hasBeenSeen" color="warning" label size="x-small" class="float-left mt-1 ml-1"> New </v-chip>
      <v-chip v-if="item.source" class="float-left mt-1 ml-1" color="primary" label size="x-small">
        <v-icon icon="mdi-fountain" start></v-icon>
        {{ item.source}}
      </v-chip>
      <v-chip v-if="item.name" class="float-left mt-1 ml-1" color="primary" label size="x-small">
        <v-icon icon="mdi-form-textbox" start></v-icon>
        {{ item.name}}
      </v-chip>
      <v-card-text class="mt-1">
        <p>{{ item.message }}</p>
        <v-sheet
          v-if="item.jsonString"
          color="grey-lighten-5"
          elevation="1"
          style="white-space: pre-wrap"
          class="pa-1 mono"
        >
          {{ item.jsonString }}
        </v-sheet>
      </v-card-text>
      <v-btn
        v-if="item.raw"
        prepend-icon="mdi-eye-settings-outline"
        size="x-small"
        class="float-right mr-2 mb-2"
        variant="tonal"
        @click="() => showRawEvent(item)"
        >Show Raw event</v-btn
      >
    </v-card>
    <template v-slot:append>
      <v-divider></v-divider>
      <div class="pa-2 d-flex justify-sm-end">
        <v-btn prepend-icon="mdi-delete-circle-outline" class="mr-2" @click="markAllEventsAsSeen"> Clear Events </v-btn>
        <v-btn prepend-icon="mdi-close-circle-outline" color="primary" @click="model=false"> Close </v-btn>
      </div>
    </template>
  </v-navigation-drawer>

  <v-dialog v-model="showRawEventDialog" width="95%">
    <v-card class="pa-5" title="Raw event data">
      <v-card-text style="white-space: pre-wrap" class="pa-1 mono"> {{ rawFormattedEvent }} </v-card-text>

      <template #actions>
        <v-btn class="ms-auto" text="Close" @click="showRawEventDialog = false"></v-btn>
      </template>
    </v-card>
  </v-dialog>
</v-layout>
